import { points, polygon,pointsWithinPolygon, booleanOverlap } from "@turf/turf";
class MapsHelper{
  //TODO -replace this code with turf Library function 
    static distance(position1, position2) {
        const lat1 = position1[0];
        const lat2 = position2[0];
        const lon1 = position1[1];
        const lon2 = position2[1];
        const R = 6371000; // metres
        const T1 = lat1 * (Math.PI / 180);
        const T2 = lat2 * (Math.PI / 180);
        const T3 = (lat2 - lat1) * (Math.PI / 180);
        const T4 = (lon2 - lon1) * (Math.PI / 180);

        const a =
          Math.sin(T3 / 2) * Math.sin(T3 / 2) +
          Math.cos(T1) * Math.cos(T2) * Math.sin(T4 / 2) * Math.sin(T4 / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const d = R * c;
        return d;
      }
      static getNearestPoint(Point, Markers) {
        let closest = Markers[0];
        let closestDistance = this.distance(
          [closest.latitude, closest.longitude],
          [Point.lat, Point.lng]
        );
        for (let i = 1; i < Markers.length; i += 1) {
          const distance = this.distance(
            [Markers[i].latitude, Markers[i].longitude],
            [Point.lat, Point.lng]
          );
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = Markers[i];
          }
        }

        return closest;
    }

    static getLocationWithinBounds = (bounds, locationObjectArray) => {
      if(bounds.length === 0 || locationObjectArray.length === 0 ){
          return [];
      }

       const locationInsideBounds = [];
       const mapBounds = polygon([...bounds]);

       locationObjectArray.map(locationObject => {
          const location = points([[locationObject.longitude, locationObject.latitude],[locationObject.longitude, locationObject.latitude]]);
          const value = pointsWithinPolygon(location, mapBounds);
          if(value.features.length){
              locationInsideBounds.push(locationObject);
          }
       });

       return locationInsideBounds;

  }

  static checkIfOverlappingRegions = (geoDataList, newBoundary) => {
    return geoDataList.some(
      (eachRegion) => eachRegion.id !== newBoundary.id && booleanOverlap(eachRegion, newBoundary)
    );
  };

}
export default MapsHelper;